import { useCallback, useEffect, useState } from 'react';

let logoutTimer;

export const useAuth = () => {
   const [token, setToken] = useState(false);
   const [tokenExpirationDate, setTokenExpirationDate] = useState();
   const [userId, setUserId] = useState(false);
   const [role, setRole] = useState();

   const login = useCallback((uid, role, token, expirationDate) => {
      setUserId(uid);
      setRole(role);
      setToken(token);

      const tokenExpirationDate =
         expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);

      setTokenExpirationDate(tokenExpirationDate);

      localStorage.setItem(
         'userData',
         JSON.stringify({
            userId: uid,
            role: role,
            token: token,
            expiration: tokenExpirationDate.toISOString(),
         })
      );
   }, []);

   const logout = useCallback(() => {
      setUserId(null);
      setRole(null);
      setToken(null);
      setTokenExpirationDate(null);

      localStorage.removeItem('userData');
   }, []);

   useEffect(() => {
      if (token && tokenExpirationDate) {
         const remainingTime =
            tokenExpirationDate.getTime() - new Date().getTime();

         logoutTimer = setTimeout(logout, remainingTime);
      } else {
         clearTimeout(logoutTimer);
      }
   }, [token, logout, tokenExpirationDate]);

   useEffect(() => {
      const storedData = JSON.parse(localStorage.getItem('userData'));

      if (
         storedData &&
         storedData.token &&
         new Date(storedData.expiration) > new Date()
      ) {
         login(
            storedData.userId,
            storedData.role,
            storedData.token,
            new Date(storedData.expiration)
         );
      }
   }, [login]);

   return { userId, role, token, login, logout };
};
